<div (click)="suggested()" 
        class="suggestion-chip py-2 px-3 flex self-stretch rounded-lg w-100% font-normal">
        {{wording}}
</div>
